import React from 'react';

// types
import PropTypes from 'prop-types';

// styles
import {
  BrokerWrapper,
  CopyrightArea,
  FooterLogo,
  FooterWrapper,
} from './Footer.style';

// assets
import { POWERED_BY_LOGO } from '../../constants/assets';

// libs
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Footer = ({ tenant }) => {
  // destructure tenant
  const { footerBrokerContent, name: tenantName } = tenant;

  // Broker contents  component
  const BrokerSection = () => (
    <section dangerouslySetInnerHTML={{ __html: footerBrokerContent }} />
  );

  // Copyright  component
  const Copyright = () =>
    `Copyright @ ${new Date().getFullYear()} ${tenantName} `;

  return (
    <FooterWrapper>
      <BrokerWrapper>{footerBrokerContent && <BrokerSection />}</BrokerWrapper>
      <CopyrightArea>
        <Copyright />
      </CopyrightArea>
      <FooterLogo src={POWERED_BY_LOGO} alt='offerboard logo' />
    </FooterWrapper>
  );
};

Footer.propTypes = {
  tenant: PropTypes.object.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Layouts/Footer/index.js